import { jsx, jsxs } from 'react/jsx-runtime';
import { mergeStyleSets, Stack, Separator } from '@fluentui/react';
import AllPanelHeader from './Header/Header.esm.js';
import AllPanelSection from './Section.esm.js';
import { allPanel } from '../../../data/allPanel.esm.js';
import { Fragment } from 'react';
import { convertTitleToId } from '../utils.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var noop = function() {
    return undefined;
};
var classNames = mergeStyleSets({
    separator: {
        height: 36
    }
});
function geSectionData(key, filtersSection, buttons, flags) {
    if (!flags.showFilters) return null;
    var allPanelData = [];
    if (flags.showHighLevel) {
        var url = buttons[0].url;
        var filterList = filtersSection.map(function(filter) {
            return {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                url: filter.subTitle.subTitle.url,
                title: filter.title,
                iconSize: 0
            };
        });
        allPanelData.push({
            title: key,
            filtersList: filterList,
            url: url
        });
    } else if (flags.divideLevel) {
        filtersSection.forEach(function(filter, index) {
            var url = buttons[index].url;
            allPanelData.push({
                title: filter.title,
                filtersList: filter.filters,
                url: url
            });
        });
    } else {
        var url1 = buttons[0].url;
        allPanelData.push({
            title: key,
            filtersList: filtersSection[0].filters,
            url: url1
        });
    }
    allPanelData.forEach(function(data) {
        data.filtersList = data.filtersList.map(function(filter) {
            return flags.showImages ? _object_spread_props(_object_spread({}, filter), {
                iconSize: 20
            }) : _object_spread_props(_object_spread({}, filter), {
                icon: ''
            });
        });
    });
    return allPanelData;
}
function AllPanelList(param) {
    var sectionTitle = param.sectionTitle, filtersSection = param.filtersSection, buttons = param.buttons, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? noop : _param_onClick;
    var flags = allPanel[sectionTitle];
    var allPanelData = geSectionData(sectionTitle, filtersSection, buttons, flags);
    return allPanelData ? /*#__PURE__*/ jsx(Stack, {
        children: allPanelData.map(function(data, index) {
            var title = data.title, filtersList = data.filtersList, url = data.url;
            return /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(AllPanelSection, {
                        onClick: onClick,
                        title: title,
                        filtersList: filtersList,
                        url: url
                    }),
                    index < allPanelData.length - 1 && /*#__PURE__*/ jsx(Separator, {
                        className: classNames.separator
                    })
                ]
            }, convertTitleToId(title));
        })
    }) : /*#__PURE__*/ jsx(AllPanelHeader, {
        title: sectionTitle,
        url: buttons[0].url,
        onClick: onClick
    });
}

export { AllPanelList as default };
